module.exports = __webpack_public_path__ + "img/d2.86eff9fa.jpg";